import React from 'react'

const DisjointSet = () => {
  return (
    <div>
        <iframe src="https://visualgo.net/en/ufds?slide=1" width="100%" height="920px" title="DisjointSet"></iframe>
    </div>
  )
}

export default DisjointSet